import React, {useState} from "react";
import {useProfile} from "../../UserProfileProvider";
import {useRpcSender} from "../../RpcSender";
import {RpcState} from "../../util/RpcState";
import {space, VerificationRequest, VerificationResponse} from "../../compiled";
import {ActionButton} from "../../util/UI/ActionButton";
import ContactMethodType = space.kenko.proto.ContactMethodType;

type Props = {
  type: ContactMethodType,
  value: string | null | undefined,
  onDone: () => void,
}

export const VerifyContactMethodOverlay = (props: Props) => {

  const {setProfile} = useProfile();

  const rpcSender = useRpcSender()

  // If success, goes to the second state.
  const [sendOtpRpcState, setSendOtpRpcState] = useState<RpcState>({state: 'none'});
  const [verifyOtpState, setVerifyRpcState] = useState<RpcState>({state: 'none'});

  const [verificationCode, setVerificationCode] = useState<string>('');

  const sendOtp = () => {

    setSendOtpRpcState({state: 'pending'})

    let request = VerificationRequest.encode(new VerificationRequest({
      type: props.type,
      value: props.value,
    })).finish();

    rpcSender.send('send_verification', request)
        .then(resp => {
          let response = VerificationResponse.decode(resp);
          if (!response.okay) {
            setSendOtpRpcState({state: 'error', message: response.error})
            return;
          }
          setSendOtpRpcState({state: 'success'})
        }).catch(e => {
      setSendOtpRpcState({state: 'error', message: 'Network error. Please try again later'})
    });
  }

  const sendVerification = () => {

    setVerifyRpcState({state: 'pending'})

    let request = VerificationRequest.encode(new VerificationRequest({
      value: verificationCode,
    })).finish();

    rpcSender.send('check_verification_code', request)
        .then(resp => {
          let response = VerificationResponse.decode(resp);
          if (!response.okay) {
            setVerifyRpcState({state: 'error', message: response.error})
            return;
          }
          setVerifyRpcState({state: 'success'})
          if (response.updatedUser) {
            setProfile(response.updatedUser);
          }

          props.onDone();

        }).catch(e => {
      setVerifyRpcState({state: 'error', message: 'Network error. Please try again later'})
    });
  }

  return <>

    {sendOtpRpcState.state != 'success' &&
        <div style={{display: 'flex', gap: 20, paddingTop: 10, paddingBottom: 5}}>
          <div>
            <ActionButton rpcState={sendOtpRpcState} smaller
                          onClick={sendOtp}>send verification code</ActionButton>
          </div>

          <div>
            <ActionButton secondary smaller onClick={props.onDone}>cancel</ActionButton>
          </div>
        </div>
    }

    {sendOtpRpcState.state == 'error' && <div className={'ErrorText'}>{sendOtpRpcState.message}</div>}


    {sendOtpRpcState.state == 'success' &&
        <div style={{display: 'flex', gap: 20, paddingTop: 10, paddingBottom: 5}}>

          <input type="text" className={'LabeledTextInput'}
                 placeholder="Enter verification code"
                 onChange={e => setVerificationCode(e.target.value)}/>

          <ActionButton smaller rpcState={verifyOtpState}
                        onClick={sendVerification}>verify now</ActionButton>
        </div>
    }

    {verifyOtpState.state == 'error' && <div className={'ErrorText'}>{verifyOtpState.message}</div>}

  </>;
};